// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myAccountDetailsPagesLayout } from "@guestsupply/App/Widgets/Layout/MyAccountDetailsPagesLayout";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

myAccountDetailsPagesLayout.container = {
    css: css`
        display: flex;
        flex-direction: column;
        @media print {
            display: block;
        }
    `,
};

myAccountDetailsPagesLayout.titleContainer = {
    css: css`
        margin-bottom: 15px;
        @media print {
            display: flex;
            width: 100%;
        }
    `,
};

myAccountDetailsPagesLayout.informationContainer = {
    css: css`
        display: flex;
        gap: 25px;
        ${xScreen("lte", "sm")} {
            flex-direction: column-reverse;
        }
        @media print {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-box-direction: reverse;
            display: flex;
            flex-direction: column-reverse;
            -webkit-flex-direction: column-reverse;
        }
    `,
};
myAccountDetailsPagesLayout.information = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        @media print {
            display: block;
            h2 {
                font-size: 15px;
            }
        }
        ${xScreen("lte", "sm")} {
            flex: 1 1 100%;
            width: 100%;
        }
    `,
};
myAccountDetailsPagesLayout.productList = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        @media print {
            display: block;
        }
    `,
};
myAccountDetailsPagesLayout.total = {
    css: css`
        flex: 0 0 319px;
        ${xScreen("lte", "sm")} {
            flex: unset;
        }
        @media print {
            display: block;
            margin-bottom: 26px;
        }
    `,
};
myAccountDetailsPagesLayout.productLisContainer = {
    css: css`
        &:empty,
        &:has(> div:empty) {
            display: none;
        }
        @media print {
            display: block;
        }
    `,
};
myAccountDetailsPagesLayout.xngStickyStyles = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};
myAccountDetailsPagesLayout.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
    `,
};

myAccountDetailsPagesLayout.informationDetailsWrapper = {
    css: css`
        display: flex;
        column-gap: 22px;
        ${xScreen("lt", "md")} {
            flex-direction: column;
        }
        margin-bottom: 26px;
        @media print {
            display: block;
        }
    `,
};
